<template>
    <div class="modal-card upload-model">
        <header class="modal-card-head has-background-white">
            <h3 class="modal-card-title has-text-centered is-size-3">
                Asignación de Analistas a Compañias
            </h3>
            <button class="delete" aria-label="Cerrar Modal" @click="$emit('close')"></button>
        </header>
        <section class="section-analysts">
            <div role="navigation" aria-label="main navigation" class="analyst_users">

                <div class="">
                    <a class="mr-3 mb-3 button is-rounded candidate_analyst" :class="[{ 'added_analyst': addedAnalysts.includes(user.user_id) },
                    { 'deleted_analyst': deletedAnalysts.includes(user.user_id) },
                    { 'selected_analyst': analistas.includes(user.user_id) }]" @click="() => escogerAnalista(user)"
                        v-for="user in analysts_list" v-bind:key="user.user_id">
                        {{ user.user_email }}
                    </a>
                </div>

            </div>
        </section>
        <section class="section-filter centered_div">
            <table>
                <tr>
                    <td class="filtrar_text">Filtrar compañias:</td>
                    <td><input type="text" v-model="filterCompany" /></td>
                </tr>
            </table>
        </section>
        <section class="section-companies">
            <div role="navigation" aria-label="main navigation" class="analyst_users">
                <table>
                    <tr v-for="companies_sub_list in companies_list" v-bind:key="companies_sub_list[0].id">
                        <td v-for="company in companies_sub_list" v-bind:key="company.id" class="company_td">
                            <button :class="['company_button', { 'selected_company': company.c_id == selectedCompany }]"
                                @click="pickCompany(company)">
                                <div class="nobreak">
                                    {{ company.rut + ' ' + company.name }}
                                </div>
                                <div class="nombre_email nobreak">
                                    {{ company.email }}
                                </div>
                                <div class="nombre_email nobreak">
                                    {{ company.nombre + ' ' + company.apellido }}
                                </div>
                            </button>
                        </td>
                    </tr>
                </table>
            </div>
        </section>
        <footer class="modal-card-foot bt-none has-background-white is-justify-content-flex-end">
            <button class="button" @click="$emit('close')" aria-label="Cerrar Modal" role="button">
                Volver
            </button>
            <button class="button is-primary" :disabled="loading || isInvalidForm" role="button"
                @click="grabarAnalistas()">
                Grabar
            </button>
        </footer>
    </div>
</template>

<script>
import { allAnalysts, allCompanies, saveCartera } from "@/api/carteraAnalista";

export default {
    name: "AssignAnalysts",
    data() {
        return {
            analysts_list: [],
            companies_list: [],
            raw_companies_list: [],
            analistas: [],
            addedAnalysts: [],
            deletedAnalysts: [],
            selectedUserId: -1,
            selectedCompany: -1,
            filterCompany: "",
            loading: false,
        };
    },
    components: {
    },
    computed: {
        isInvalidForm: function () {
            if (this.selectedCompany != -1 && this.addedAnalysts.length > 0 || this.deletedAnalysts.length > 0) {
                return false
            }
            return true
        }
    },
    methods: {
        pickCompany(company) {
            if (this.selectedCompany == company.c_id) {
                this.selectedCompany = -1;
                this.analistas = [];
                this.addedAnalysts = [];
                this.deletedAnalysts = [];
            } else {
                this.selectedCompany = company.c_id;
                if (company.analistas) {
                    this.analistas = [];
                    this.addedAnalysts = [];
                    this.deletedAnalysts = [];
                    company.analistas.forEach((elem) => this.analistas.push(elem.user_id));
                }
            }
        },
        escogerAnalista(user) {
            if (this.analistas.includes(user.user_id)) {//borrando? o desborrando
                if (this.deletedAnalysts.includes(user.user_id)) {
                    //desborrando
                    const index = this.deletedAnalysts.indexOf(user.user_id);
                    this.deletedAnalysts.splice(index, 1);
                } else {
                    //borrando
                    this.deletedAnalysts.push(user.user_id);
                }
            } else { //annadiendo o desannadiendo
                if (this.addedAnalysts.includes(user.user_id)) {
                    //desannadiendo
                    const index = this.addedAnalysts.indexOf(user.user_id);
                    this.addedAnalysts.splice(index, 1);
                } else {
                    //annadiendo
                    this.addedAnalysts.push(user.user_id);
                }
            }
        },
        calcSize(largo) {
            return Math.ceil(Math.log(largo + 1));
        },
        partition(list) {
            var result = [];
            const largo = list.length;
            const size = this.calcSize(largo);
            for (var i = 0; i < largo; i = i + size) {
                result.push(list.slice(i, i + size));
            }
            return result;
        },
        filterCompanies() {
            if (this.filterCompany == "") {
                this.companies_list = this.partition(this.raw_companies_list);
            } else {
                console.log('filtrando por:', this.filterCompany);
                const lesser_companies = this.raw_companies_list.filter(
                    (company) => company['all_text'].includes(this.filterCompany.toUpperCase())
                );
                this.companies_list = this.partition(lesser_companies);
            }
        },
        async grabarAnalistas() {
            this.loading = true;
            const value = await saveCartera(this.selectedCompany, this.analistas, this.addedAnalysts, this.deletedAnalysts);
            this.loading = false;
            console.log('value:', JSON.stringify(value.data));
            const companies_total = this.raw_companies_list.length;
            for (let index = 0; index < companies_total; index++) {
                const this_company = this.raw_companies_list[index];
                if (this_company['c_id'] == this.selectedCompany) {
                    const obj_users = JSON.parse(JSON.stringify(value.data['updated_analistas']));
                    this_company['analistas'] = obj_users;
                    this.raw_companies_list[index]['analistas'] = obj_users;
                    console.log('this_company:', JSON.stringify(this.raw_companies_list[index]));
                    this.filterCompanies();
                    this.analistas = JSON.parse(JSON.stringify(value.data['user_ids']));
                    console.log('this.analistas:', this.analistas, ' value:', value.data['user_ids']);
                    console.log('this.analistas:', JSON.stringify(this.analistas),
                        ' value:', JSON.stringify(value.data['user_ids']));
                    this.addedAnalysts = [];
                    this.deletedAnalysts = [];
                    break;
                }
            }
        },
    },
    mounted() {
        allAnalysts().then((response) => {
            this.analysts_list = response.data;
        })
            .catch((error) => {
                console.log('error:', error);
            });
        allCompanies().then((response) => {
            this.raw_companies_list = response.data;
            this.filterCompanies();
        }).catch((error) => {
            console.log('error:', error);
        });
    },
    watch: {
        filterCompany(newValue) {
            console.log('new value:', newValue);
            this.filterCompanies();
        }
    },
};
</script>
<style scoped>
.upload-model {
    text-align: center;
    width: 100%;
    height: 1000px;
}

.analyst_users {
    padding-top: 10px;
    padding-left: 30px;
}

.nombre_email {
    font-size: 80%;
}

.company_td {
    border: 0px solid #000000;
    padding: 0 5px 0 5px;
}

.section-analysts {
    background-color: #FcFdFf;
}

.section-filter {
    height: 50px;
    overflow: visible;
    background-color: #FbFcFe;
    padding: 5px 0 5px 0;
}

.section-companies {
    background-color: #F8F9Fd;
    overflow: auto;
}

.centered_div {
    display: flex;
    justify-content: center;
    align-items: center;
}

.filtrar_text {
    padding-right: 5px;
}

.modal-card-body {
    padding-top: 10px !important;
}

.selected_company {
    background-color: #ffff00 !important;
    border-color: #000000 !important;
}

.company_button {
    cursor: pointer;
    justify-content: center;
    border: 1px solid #444444;
    background-color: #ffffff;
    border: 1px solid #dddddd;
    padding: 2%;
    margin: 2px;
}

.company_button:hover {
    background-color: #fffff3;
    transform: translateY(-2px);
}

.company_button:active {
    transform: translateY(1px);
}

.nobreak {
    white-space: nowrap;
}

.selected_analyst {
    background-color: #ffff00;
    border-color: #000000 !important;
    color: #000000;
}

.candidate_analyst {
    border: 1px solid #dddddd;
}

.added_analyst {
    background-color: #eeee99;
}

.added_analyst:after {
    content: '+';
    padding-left: 6px;
    font-size: 130%;
    font-weight: bold;
    -webkit-text-stroke: white 1px;
}

.deleted_analyst {
    background-color: #ffffbb !important;
    text-decoration: line-through;
    text-decoration-thickness: 2px;
}

.deleted_analyst:after {
    content: '-';
    padding-left: 6px;
    font-size: 130%;
    font-weight: bold;
    -webkit-text-stroke: white 1px;
}
</style>